module.exports = __webpack_public_path__ + "static/1-47a3f33fc9f2ddac4f8f14f9e3cebbea.png";